import React from 'react';
import BookOfRa from '../../../assets/book_of_ra.jpg';
import DolphinsPearl from '../../../assets/dolphins_pearl.jpg';
import LuckyLadysCharm from '../../../assets/lucky_ladys_charm.jpg';
import Sizzing from '../../../assets/sizzling_hot_deluxe.jpg';
import Wordertree from '../../../assets/wondertree.jpg';
import makeStyles from '@material-ui/core/styles/makeStyles';
import { translate } from '../../dictionaries';

const useStyles = makeStyles(() => ({
    "@global": {
        "@keyframes rotateGame": {
            "0%": {
                transform: "rotate(2deg)"
            },

            "100%": {
                transform: "rotate(-2deg)"
            },

        },
        "@keyframes rotateBtn": {
            "0%": {
                transform: "rotate(-8deg)"
            },

            "100%": {
                transform: "rotate(8deg)"
            },

        },
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        // flexDirection: 'column',
        width: 'calc(100% - 40px)',
        justifyContent: 'center',
        alignItems: 'center',
        rowGap: 20,
        columnGap: 20,
        margin: '20px',
        paddingBottom: 40,
        marginTop: 40
    },
    game: {
        width: 150,
        borderRadius: 12,
        boxShadow: '1px 1px 10px 0 rgba(0,0,0,.4)',
        cursor: 'pointer',
        'animation-iteration-count': 'infinite',
        animationDuration: '.3s',
        animationDirection: 'alternate',
        animationName: 'rotateGame',
    },
    game2: {
        width: 150,
        borderRadius: 12,
        boxShadow: '1px 1px 10px 0 rgba(0,0,0,.4)',
        cursor: 'pointer',
        '&:hover': {
            'animation-iteration-count': 'infinite',
            animationDuration: '.3s',
            animationDirection: 'alternate',
            animationName: 'rotateGame',
        }
    },
    pl100: {
        paddingLeft: 0
    },
    wrapBtn: {
        width: 150,
        background: '#FF005C',
        padding: '16px 0',
        boxShadow: '-4px 6px 23px rgba(0, 0, 0, 0.41), 7px -10px 21px -11px rgba(255, 0, 92, 0.31)',
        backdropFilter: 'blur(61px)',
        borderRadius: 11,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        color: '#fff',
        fontFamily: 'Circe, sans-serif',
        fontWeight: 700,
        cursor: 'pointer',
        'animation-iteration-count': 'infinite',
        animationDuration: '.2s',
        animationDirection: 'alternate',
        animationName: 'rotateBtn',
    },

}))



const Slot = ({ handleSetIsShowModal }) => {
    const classes = useStyles();
    return (
        <div style={{ position: 'absolute', top: 0, right: 0 }}>
            <div className={classes.root} style={{ display: 'flex', flexDirection: 'column' }}>
                <img
                    src={BookOfRa}
                    alt=""
                    className={classes.game}
                    onClick={() => handleSetIsShowModal(true)}
                />
                <img src={DolphinsPearl} alt="" className={classes.game2} onClick={() => handleSetIsShowModal(true)} />
                <img src={LuckyLadysCharm} alt="" className={classes.game2} onClick={() => handleSetIsShowModal(true)} />
                <img src={Sizzing} alt="" className={classes.game2} onClick={() => handleSetIsShowModal(true)} />
                <img src={Wordertree} alt="" className={classes.game2} onClick={() => handleSetIsShowModal(true)} />

                <div style={{ display: 'flex', justifyContent: 'center', }}>
                    <div className={classes.pl100} onClick={() => handleSetIsShowModal(true)} style={{ display: 'flex', alignItems: 'center', marginTop: 50, marginLeft: 20 }}>
                        <div className={classes.wrapBtn}>
                            <span>{translate('common.next')}</span>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Slot;